import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from "react-router-dom";
import { connect } from "react-redux";
import { useQuery } from "@apollo/client";
import styled from 'styled-components'
import { hideAutoSuggest, hideBackArrow, hideModalBokecc, hideSearchBar, setTitleBar } from "../../../actions/ui";
import { Black, Shadow, WerfenColor } from '../../Constants/ColorChart';
import {
    getFields as getFieldsToShow,
    processAsPlaylist,
    processAsResource,
    triggerLinkAnalytics
} from "../../../../web/Utils/utils";
import Loader from '../Loader/Loader'
import { LINK_QUERY } from "./Queries/LinkQuery";
import ResultTable from "../ResultTable/ResultTable";
import { Modal } from "react-bootstrap";

const StyledDiv = styled.div`
  margin-top: 110px;
  width: calc(100% - 20px);
  margin-left: auto;
  margin-right:auto;
  @media (min-width: 765px){
      margin-top: 150px;
      width: 90%;
  }
`;

const StyledModalBody = styled.div`
    height: 0px;
    padding-bottom: 50%;
    iframe {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }
`;

const Link = ( props ) => {
    const [ analyticsSent, setAnalyticsSent ] = useState ( false );
    const id = useParams ().id;
    const itemIndex = useParams ().index || undefined;
    const history = useHistory ();

    useEffect ( () => {
        props.hideBackArrow ();
        props.hideSearchBar ();
        props.setTitleBar ( "Link" );

        if ( !id ) {
            history.push ( "/" )
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );


    const createMarkup = ( html ) => {
        return { __html: html }
    }

    const classifyResults = ( result, index ) => {
        let output = [];
        let data;
        let fields = [ "title" ];

        let fieldsExcludes = ["name", "filesize", "entityBundle", "entityChanged", "entityCreated", "description", "tags"];
        if (process.env.REACT_APP_SEE_VERSION !== "1") {
          fieldsExcludes.push("version");
        }

        if ( result ) {
            switch ( result.entityBundle ) {
                case "playlist":
                    output = processAsPlaylist ( result );
                    break;
                case "resource":
                    if ( result.fieldResourceFilesByFormat.length > 0 ) {
                        output = processAsResource ( result, index );
                    }
                    fields = getFieldsToShow(output.metadata, fieldsExcludes);
                    break;
                default:
                    break;
            }
            if ( !analyticsSent ) {
                const data = {
                    title: output.metadata.name ? output.metadata.name : output.metadata.title,
                    type: output.type,
                    id,
                    itemIndex
                }
                triggerLinkAnalytics ( data, props.session.user );
                setAnalyticsSent ( true );
            }

            if ( Array.isArray ( output ) ) {
                data = output
            } else {
                data = [ output ]
            }

            return { data, fields };
        }

    }

    const { loading, error, data } = useQuery ( LINK_QUERY,
        {
            variables: { "id": String ( id ) },
            fetchPolicy: "no-cache"
        } );

    if ( loading ) {
        return (
            <StyledDiv>
                <Loader
                    message="Getting content"
                    primaryColor={ WerfenColor }
                    secondaryColor={ Shadow }
                    fontColor={ Black }
                    extraStyle="margin-top: 10%"
                />
            </StyledDiv>
        )
    }

    let result;
    if ( data && data.nodeById ) {
      result = data.nodeById;
    } else {
      result = null;
    }

    if ( error || null === result) {
        return (
            <StyledDiv>
                <div>
                    <h1>No data recovered</h1>
                </div>
            </StyledDiv>
        )
    }

    const item = classifyResults ( result, itemIndex );

    return (
        <div className="Link">
            <StyledDiv>
                <div>
                    <ResultTable
                        rowWidth={ 80 }
                        fieldsToShow={ item.fields }
                        data={ item.data }
                        type={ "linked_item" }
                        title={""}
                        tableUnified={false}
                    />
                </div>
            </StyledDiv>
            <Modal show={ props.visibleModalBokecc }
                   onHide={ props.hideModalBokecc }
                   size="lg"
                   backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{ props.modalTitle }</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <StyledModalBody dangerouslySetInnerHTML={ createMarkup ( props.modalBody ) }/>
                </Modal.Body>
            </Modal>
        </div>
    )
}

const mapStateToProps = ( state ) => ( {
    loadedPlaylist: state.playlist,
    loadedResource: state.resource,
    settings: state.settings,
    session: state.session,
    refresh: state.search.haveToSearch,
    searchString: state.search.searchString,
    visibleModalBokecc: state.ui.visibleModalBokecc,
    modalTitle: state.ui.modalTitle,
    modalBody: state.ui.modalBody,
} );

export default connect ( mapStateToProps, {
    setTitleBar,
    hideAutoSuggest,
    hideBackArrow,
    hideModalBokecc,
    hideSearchBar,
} ) ( Link );
